<template>
  <div>
    <div v-if="showClose" class="comp-close">
      <v-btn small text icon @click="close()" :disabled="!$auth.manage || isHistory">
        <icon-svg iconName="comp-close" />
      </v-btn>
    </div>
    <v-card class="proc-component">
      <v-card-title class="proc justify-center darken-1" @dblclick="openRightLayer()">
        <icon-svg :size="procIconSize" iconName="proc-usr" />
      </v-card-title>
    </v-card>
  </div>
</template>

<script>
import EventBus from '@/vue-caas/views/process/component/event-bus.js';
import IconSvg from '@/vue-caas/components/IconBase.vue';

export default {
  components: {
    IconSvg,
  },
  props: {
    comId: {
      default: '',
    },
    isHistory: {
      default: false,
    },
    comTp: {
      default: 'USR',
    },
    setDisable: {
      default: false,
    },
    manage: {
      default: false,
    },
  },
  data() {
    return {
      procIconSize: 24,
      showClose: false,
      formData: {
        uc_id: '',
        uc_type: '',
        userType: '',
        uc_ver: '',
      },
      usrItem: [],
      userDisable: false,
      nodeId: '',
      formEmit: {
        comTp: 'USR',
        comId: '',
        nodeId: '',
      },
    };
  },
  watch: {
    comId() {
      return this.comId;
    },
    userDisable() {
      this.formEmit.userDisable = this.userDisable;
    },
  },
  mounted() {},
  methods: {
    resetForm() {
      this.formData = {
        uc_id: '',
        uc_type: '',
        userType: '',
        uc_ver: '',
      };
      this.formEmit = {
        comId: '',
        nodeId: this.nodeId,
        comName: '',
        comTp: this.comTp,
        userDisable: this.userDisable,
      };
      EventBus.$emit('set-comp-id', this.formEmit);
    },
    changeComponentData(id, nodeId) {
      if (nodeId === this.nodeId) {
        this.formData.uc_id = id;
        if (!this.formData.uc_id) {
          this.resetForm();
          return;
        }
        this.selectUser();
      }
    },
    openRightLayer() {
      if (this.manage || this.isHistory) {
        EventBus.$emit('open-right-layer', this.formEmit);
      }
    },
    selectUser() {
      const id = this.formData.uc_id;
      let index = this.userList.findIndex((e) => e.uc_id == id);
      if (index > -1 && (this.manage || this.isHistory)) {
        this.hideItem = false;
        this.formData = Object.assign({}, this.userList[index]);
        this.formData.userType = this.formData.uc_type == 'C' ? 'UCC' : 'UCR';
        this.formEmit = {
          comId: this.formData.uc_id,
          nodeId: this.nodeId,
          comName: this.formData.uc_name,
          comTp: this.comTp,
          userDisable: this.userDisable,
        };
        EventBus.$emit('set-comp-id', this.formEmit);
      } else {
        this.resetForm();
      }
    },
    openMapperVersion() {
      EventBus.$emit('open-user-component-version', this.formData);
    },
    close() {
      EventBus.$emit('close', this.nodeId);
    },
    async initialize() {
      this.$nextTick(() => {
        this.nodeId = this.$el.parentElement.parentElement.id;
        this.userDisable = this.setDisable;
        this.formData.uc_id = this.comId;
        if (this.formData.uc_id !== '') {
          this.selectUser();
        } else {
          this.formEmit = {
            comId: '',
            nodeId: this.nodeId,
            comName: '',
            comTp: this.comTp,
            userDisable: this.userDisable,
          };
          EventBus.$emit('set-comp-id', this.formEmit);
        }
      });
    },
  },
  created() {
    this.initialize();
    EventBus.$on('change-component-data', this.changeComponentData);
  },
  computed: {
    userList() {
      return this.$store.getters.userComponentSelectBoxList;
    },
  },
};
</script>
